/**
 * @generated SignedSource<<00934e27f3e648347e89f7b5c751cc55>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamUpdatesViewQuery$variables = {
  activeProjectsTql: string;
  cloudId?: string | null;
  completedProjectsTql: string;
  isNavRefreshEnabled: boolean;
  pausedProjectsTql: string;
  pendingProjectsTql: string;
  relatedGoalsTql: string;
  sidebarLimit: number;
  teamId: string;
  workspaceUUID: string;
};
export type TeamUpdatesViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamSidebarColumn" | "TeamUpdatesMainColumn">;
};
export type TeamUpdatesViewQuery = {
  response: TeamUpdatesViewQuery$data;
  variables: TeamUpdatesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeProjectsTql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedProjectsTql"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pausedProjectsTql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingProjectsTql"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedGoalsTql"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidebarLimit"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = {
  "kind": "Variable",
  "name": "teamId",
  "variableName": "teamId"
},
v12 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v13 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v14 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "watching"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v11/*: any*/),
  (v12/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v21 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v22 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v23 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v24 = {
  "kind": "ScalarField",
  "name": "picture"
},
v25 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v26 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v27 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v17/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        (v25/*: any*/),
        (v15/*: any*/),
        (v26/*: any*/)
      ]
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "ari"
},
v29 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    (v17/*: any*/)
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "private"
},
v31 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "key"
},
v33 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v34 = [
  (v17/*: any*/),
  (v33/*: any*/)
],
v35 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v36 = {
  "kind": "ScalarField",
  "name": "type"
},
v37 = {
  "kind": "ScalarField",
  "name": "summary"
},
v38 = [
  (v32/*: any*/),
  (v28/*: any*/),
  (v17/*: any*/)
],
v39 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/)
    ]
  },
  (v23/*: any*/),
  (v17/*: any*/)
],
v40 = {
  "kind": "ScalarField",
  "name": "count"
},
v41 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v42 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v41/*: any*/),
            (v28/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v33/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v23/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v24/*: any*/),
                    (v15/*: any*/),
                    (v26/*: any*/),
                    (v25/*: any*/)
                  ]
                },
                (v17/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ]
},
v43 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v15/*: any*/)
      ]
    },
    (v17/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "label"
},
v45 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v46 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v45/*: any*/)
},
v47 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v48 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v44/*: any*/),
  (v46/*: any*/),
  {
    "alias": "tooltip",
    "args": (v47/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v47/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v45/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v49 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "alias": "projectStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v51 = {
  "kind": "ScalarField",
  "name": "value"
},
v52 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v51/*: any*/),
    (v44/*: any*/),
    (v46/*: any*/)
  ]
},
v53 = {
  "kind": "ScalarField",
  "name": "archived"
},
v54 = {
  "kind": "ScalarField",
  "name": "title"
},
v55 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v48/*: any*/)
},
v56 = [
  (v44/*: any*/),
  (v46/*: any*/),
  (v50/*: any*/),
  (v52/*: any*/)
],
v57 = {
  "kind": "ScalarField",
  "name": "url"
},
v58 = [
  (v17/*: any*/)
],
v59 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "score"
},
v61 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v62 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v63 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v46/*: any*/),
    (v51/*: any*/),
    (v60/*: any*/)
  ]
},
v64 = [
  (v51/*: any*/),
  (v17/*: any*/)
],
v65 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "sidebarLimit"
},
v66 = [
  "LATEST_UPDATE_DATE_DESC"
],
v67 = {
  "kind": "Literal",
  "name": "sort",
  "value": (v66/*: any*/)
},
v68 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        (v25/*: any*/)
      ]
    },
    (v17/*: any*/)
  ]
},
v69 = [
  (v40/*: any*/),
  {
    "concreteType": "ProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v32/*: any*/),
          (v15/*: any*/),
          (v20/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v68/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamUpdatesViewQuery",
    "selections": [
      {
        "args": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TeamUpdatesMainColumn"
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "activeProjectsTql",
                "variableName": "activeProjectsTql"
              },
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "completedProjectsTql",
                "variableName": "completedProjectsTql"
              },
              {
                "kind": "Variable",
                "name": "pausedProjectsTql",
                "variableName": "pausedProjectsTql"
              },
              {
                "kind": "Variable",
                "name": "pendingProjectsTql",
                "variableName": "pendingProjectsTql"
              },
              {
                "kind": "Variable",
                "name": "relatedGoalsTql",
                "variableName": "relatedGoalsTql"
              },
              {
                "kind": "Variable",
                "name": "sidebarLimit",
                "variableName": "sidebarLimit"
              },
              (v11/*: any*/),
              (v13/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "TeamSidebarColumn"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamUpdatesViewQuery",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "ScalarField",
            "name": "teamId"
          },
          (v17/*: any*/)
        ]
      },
      {
        "args": (v18/*: any*/),
        "concreteType": "UpdateConnection",
        "kind": "LinkedField",
        "name": "updatesWithTeam",
        "plural": false,
        "selections": [
          {
            "concreteType": "UpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v27/*: any*/),
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v20/*: any*/),
                          (v29/*: any*/),
                          (v17/*: any*/),
                          (v16/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v15/*: any*/),
                          {
                            "concreteType": "ProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v34/*: any*/)
                          },
                          (v35/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      (v33/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "concreteType": "ProjectChangelogItem",
                        "kind": "LinkedField",
                        "name": "changelog",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "newValue"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "oldValue"
                          },
                          (v17/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "LearningConnection",
                        "kind": "LinkedField",
                        "name": "learnings",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "LearningEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Learning",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  (v20/*: any*/),
                                  (v17/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v28/*: any*/),
                                      {
                                        "concreteType": "Project",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": (v38/*: any*/)
                                      },
                                      {
                                        "concreteType": "Goal",
                                        "kind": "LinkedField",
                                        "name": "goal",
                                        "plural": false,
                                        "selections": (v38/*: any*/)
                                      },
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "creator",
                                        "plural": false,
                                        "selections": (v39/*: any*/)
                                      },
                                      (v33/*: any*/),
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "lastEditedBy",
                                        "plural": false,
                                        "selections": (v39/*: any*/)
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "lastEditedDate"
                                      }
                                    ],
                                    "type": "Highlight",
                                    "abstractKey": "__isHighlight"
                                  }
                                ]
                              }
                            ]
                          },
                          (v40/*: any*/)
                        ]
                      },
                      (v42/*: any*/),
                      (v41/*: any*/),
                      (v43/*: any*/),
                      (v49/*: any*/),
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v50/*: any*/),
                          (v44/*: any*/),
                          (v46/*: any*/),
                          (v52/*: any*/)
                        ]
                      },
                      (v37/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v37/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/)
                        ]
                      },
                      (v55/*: any*/),
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v56/*: any*/)
                      },
                      {
                        "concreteType": "MilestoneConnection",
                        "kind": "LinkedField",
                        "name": "milestones",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MilestoneEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v17/*: any*/),
                                  (v54/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDateType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "status"
                                  }
                                ]
                              }
                            ]
                          },
                          (v40/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v57/*: any*/),
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v17/*: any*/)
                                ]
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "ProjectUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v17/*: any*/),
                      (v20/*: any*/),
                      (v27/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v20/*: any*/),
                          (v29/*: any*/),
                          (v17/*: any*/),
                          (v16/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v58/*: any*/)
                          },
                          (v32/*: any*/),
                          (v15/*: any*/),
                          (v59/*: any*/),
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v34/*: any*/)
                          },
                          (v35/*: any*/),
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      (v17/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v51/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v46/*: any*/),
                          (v63/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      (v33/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v64/*: any*/)
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v15/*: any*/),
                                      (v36/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "subType"
                                      },
                                      (v53/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v64/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": [
                          (v36/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "percentage"
                          }
                        ]
                      },
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v41/*: any*/),
                      (v49/*: any*/),
                      (v37/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v53/*: any*/),
                          (v20/*: any*/),
                          (v54/*: any*/),
                          (v37/*: any*/),
                          (v17/*: any*/)
                        ]
                      },
                      (v55/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": [
                          (v62/*: any*/),
                          (v46/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v63/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v57/*: any*/)
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "GoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v58/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v19/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v18/*: any*/),
        "filters": [
          "teamId",
          "workspaceUUID"
        ],
        "handle": "connection",
        "key": "TeamUpdatesFeed_updatesWithTeam",
        "kind": "LinkedHandle",
        "name": "updatesWithTeam"
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teamByTeamId",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v58/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "activeProjectsTql",
            "args": [
              (v65/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "activeProjectsTql"
              },
              (v67/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "concreteType": "ProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v32/*: any*/),
                      (v15/*: any*/),
                      (v20/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v68/*: any*/),
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": (v56/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "pendingProjectsTql",
            "args": [
              (v65/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "pendingProjectsTql"
              },
              (v67/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": (v69/*: any*/)
          },
          {
            "alias": "pausedProjectsTql",
            "args": [
              (v65/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "pausedProjectsTql"
              },
              (v67/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": (v69/*: any*/)
          },
          {
            "alias": "completedProjectsTql",
            "args": [
              (v65/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "completedProjectsTql"
              },
              (v67/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "ProjectConnection",
            "kind": "LinkedField",
            "name": "projectTql",
            "plural": false,
            "selections": (v69/*: any*/)
          },
          {
            "alias": "relatedGoalsTql",
            "args": [
              (v65/*: any*/),
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "relatedGoalsTql"
              },
              {
                "kind": "Literal",
                "name": "sorts",
                "value": (v66/*: any*/)
              },
              (v13/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTql",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v32/*: any*/),
                      (v20/*: any*/),
                      (v59/*: any*/),
                      (v15/*: any*/),
                      (v68/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d4462ab8f4e02dc3a2f846ac121d204e",
    "id": null,
    "metadata": {},
    "name": "TeamUpdatesViewQuery",
    "operationKind": "query",
    "text": "query TeamUpdatesViewQuery(\n  $teamId: String!\n  $workspaceUUID: UUID!\n  $activeProjectsTql: String!\n  $pendingProjectsTql: String!\n  $pausedProjectsTql: String!\n  $completedProjectsTql: String!\n  $relatedGoalsTql: String!\n  $sidebarLimit: Int!\n  $cloudId: String\n  $isNavRefreshEnabled: Boolean!\n) {\n  ...TeamUpdatesMainColumn_3tmCog\n  ...TeamSidebarColumn_1FniF7 @skip(if: $isNavRefreshEnabled)\n}\n\nfragment ActiveTeamProjectsSection_2lZLtl on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  activeProjectsTql: projectTql(q: $activeProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection_1O1zBL\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CompletedTeamProjectsSection_INMK3 on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  completedProjectsTql: projectTql(q: $completedProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment FollowTeamButton on Team {\n  id\n  teamId\n  name\n  watching\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalRowWithOwner on Goal {\n  key\n  ...GoalName\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalWithOwnerSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithOwner\n    }\n  }\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PausedTeamProjectsSection_36NY8Z on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  pausedProjectsTql: projectTql(q: $pausedProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment PendingTeamProjectsSection_18ayXQ on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  pendingProjectsTql: projectTql(q: $pendingProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectRowWithOwner_1O1zBL on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ProjectRowWithOwner_4yoa7g on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newState {\n    ...ProjectState\n  }\n  oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newState {\n    projectStateValue: value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_4yoa7g\n    }\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection_1O1zBL on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_1O1zBL\n    }\n  }\n}\n\nfragment RelatedTeamGoalsSection_2a5m5U on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  relatedGoalsTql: goalTql(q: $relatedGoalsTql, workspaceUuid: $workspaceUUID, sorts: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...GoalWithOwnerSidebarSection\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamFollowerSection on Team {\n  teamId\n  watchers {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...FollowTeamButton\n}\n\nfragment TeamSidebarColumn_1FniF7 on Query {\n  ...ActiveTeamProjectsSection_2lZLtl\n  ...PendingTeamProjectsSection_18ayXQ\n  ...PausedTeamProjectsSection_36NY8Z\n  ...CompletedTeamProjectsSection_INMK3\n  ...RelatedTeamGoalsSection_2a5m5U\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    ...TeamFollowerSection\n    id\n  }\n}\n\nfragment TeamUpdatesFeed_1WsrkT on Query {\n  updatesWithTeam(teamId: $teamId, workspaceUUID: $workspaceUUID, first: 10) {\n    ...UpdatesFeed\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamUpdatesHeader on Team {\n  watching\n  name\n  teamId\n  ...FollowTeamButton\n}\n\nfragment TeamUpdatesMainColumn_3tmCog on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    name\n    ...TeamUpdatesHeader\n    id\n  }\n  ...TeamUpdatesFeed_1WsrkT\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesFeed on UpdateConnection {\n  edges {\n    node {\n      __typename\n      ... on ProjectUpdate {\n        id\n        ...ProjectUpdateCard\n      }\n      ... on GoalUpdate {\n        id\n        ...GoalUpdateCard\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0a96dc0bbb773166a2966f3d43cfc21";

export default node;
